import posthog from "posthog-js";

import { faro } from "@grafana/faro-web-sdk";

import { getPostHogConfig } from "./posthogConfig";

export const POSTHOG_REPLAY_URL_ATTRIBUTE = "posthog_replay_url";

export function buildPostHogReplayUrl({
  host,
  projectId,
  sessionId,
}: {
  host: string;
  projectId: string | undefined;
  sessionId: string | undefined;
}): string | null {
  if (!projectId || !sessionId) return null;

  return `${host}/project/${projectId}/replay/${sessionId}`;
}

export function linkPostHogReplayToFaro(): void {
  const { enabled, host, projectId } = getPostHogConfig();

  if (!enabled) return;

  const replayUrl = buildPostHogReplayUrl({
    host,
    projectId,
    sessionId: readPostHogSessionId(),
  });

  if (!replayUrl) return;

  const currentSession = faro.api.getSession();

  faro.api.setSession({
    ...currentSession,
    attributes: {
      ...currentSession?.attributes,
      [POSTHOG_REPLAY_URL_ATTRIBUTE]: replayUrl,
    },
  });
}

function readPostHogSessionId(): string | undefined {
  try {
    return posthog.get_session_id() || undefined;
  } catch {
    return undefined;
  }
}
